const ITEMS = ["Jour de match", "Réponds avant le coup d'envoi", "Présent ou absent", "Le groupe compte sur toi", "Un seul maillot"];
const ITEMS_ENTRAINEMENT = ["Jour d'entraînement", "Écoute les consignes du coach", "Présent ou absent", "On progresse ensemble", "On joue en match comme on s'entraîne"];

export const Marquee = ({ compact = false, type }) => {
  const items = type === "entrainement" ? ITEMS_ENTRAINEMENT : ITEMS;
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className={`relative overflow-hidden bg-lime text-ink ${compact ? "py-1.5" : "border-y border-line py-5"}`}>
      <div className="marquee-track flex w-max gap-10 whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex gap-10" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={i} className={`flex items-center gap-10 font-display uppercase ${compact ? "text-lg" : "text-3xl sm:text-5xl"}`}>
                {t}
                <span className={`inline-block rounded-full bg-ink ${compact ? "h-2 w-2" : "h-3 w-3"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
